export const DONATION_RETURN_PATH_KEY = 'donation_return_path';
export const DONATION_PREMIUM_GRANTED_KEY = 'donation_premium_granted';

/** Remember where to send the user after thank-you (defaults to /predict). */
export function saveDonationReturnPath(override) {
    if (typeof window === 'undefined') return;
    const path =
        override ||
        `${window.location.pathname}${window.location.search}` ||
        '/predict';
    sessionStorage.setItem(DONATION_RETURN_PATH_KEY, path.startsWith('/') ? path : '/predict');
}

export function getDonationReturnPath(defaultPath = '/predict') {
    try {
        const stored = sessionStorage.getItem(DONATION_RETURN_PATH_KEY);
        if (stored && stored.startsWith('/')) return stored;
    } catch (_) {
        /* ignore */
    }
    return defaultPath;
}

export function clearDonationReturnPath() {
    try {
        sessionStorage.removeItem(DONATION_RETURN_PATH_KEY);
    } catch (_) {
        /* ignore */
    }
}

export function markDonationPremiumGranted() {
    try {
        sessionStorage.setItem(DONATION_PREMIUM_GRANTED_KEY, '1');
    } catch (_) {
        /* ignore */
    }
}

export function consumeDonationPremiumGranted() {
    try {
        const ok = sessionStorage.getItem(DONATION_PREMIUM_GRANTED_KEY) === '1';
        sessionStorage.removeItem(DONATION_PREMIUM_GRANTED_KEY);
        return ok;
    } catch (_) {
        return false;
    }
}
